import { Button } from "@/components/elements/Button";
import { EMPTY_STR } from "@/constants/string";
import { AppRoutes } from "@/routes/config";
import { TPagination } from "@/types/api";
import { formatNumber } from "@/utils/number";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TContactTypeListTopProps = {
  isCompany?: boolean;
  pagination?: TPagination;
};

export const ContactTypeListTop: FC<TContactTypeListTopProps> = ({ isCompany = false, pagination }) => {
  const totalText = pagination ? formatNumber(pagination.total) : EMPTY_STR.TEXT;
  const displayedText = pagination ? formatNumber((pagination.page - 1) * pagination.perPage + pagination.count) : EMPTY_STR.TEXT;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body14">{`全 ${totalText} 件中 ${displayedText} 件を表示`}</Typography>
      <Button component={Link} size="sm" variant="outline" to={isCompany ? AppRoutes.companyContactTypeCreate : AppRoutes.contactTypeCreate}>
        新規作成
      </Button>
    </Stack>
  );
};
